// The one list of languages InmoTera supports: marketing site, dashboard, emails and agency websites.
// To add a language: add one line here, the same code to LANGS in backend/core.py
// (`yarn i18n:check` and backend tests fail if they differ), then run `yarn i18n:check` to list the strings to translate.
export const LANGUAGES = [
  { code: "en", name: "English", locale: "en-GB" },
  { code: "es", name: "Español", locale: "es-ES" },
  { code: "de", name: "Deutsch", locale: "de-DE" },
  { code: "fr", name: "Français", locale: "fr-FR" },
  { code: "nl", name: "Nederlands", locale: "nl-NL" },
  { code: "sv", name: "Svenska", locale: "sv-SE" },
  { code: "no", name: "Norsk", locale: "nb-NO" },
  { code: "it", name: "Italiano", locale: "it-IT" },
  { code: "pt", name: "Português", locale: "pt-PT" },
  { code: "ru", name: "Русский", locale: "ru-RU" },
  { code: "pl", name: "Polski", locale: "pl-PL" },
];
export const LANG_CODES = LANGUAGES.map((l) => l.code);
export const LOCALES = Object.fromEntries(LANGUAGES.map((l) => [l.code, l.locale]));
export const LANG_NAMES = Object.fromEntries(LANGUAGES.map((l) => [l.code, l.name]));
export const isLang = (l) => LANG_CODES.includes(l);
